import { createSupportWidgetController, isSupportWidgetEnabled } from '~/utils/supportWidget'

/**
 * サポートチャットウィジェット（client-only）
 * ログイン中の店舗・スタッフが揃ったら loader.js を1回注入し、ログアウトで片付ける。
 * 設計書: docs/plans/2026-09-18-cmp-support-widget-design.md
 */
export default ({ store }) => {
  if (!isSupportWidgetEnabled()) return

  const ctl = createSupportWidgetController({ win: window, doc: document })

  store.watch(
    (state) => `${state.auth.company?.uid || ''}:${state.auth.staff?.uid || ''}`,
    () => ctl.inject(store.state.auth),
    { immediate: true }
  )

  store.subscribe((mutation) => {
    if (mutation.type === 'auth/logout') ctl.teardown()
  })
}
